import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },     
    {
      path: '/processing/scaling',
      name: 'Scaling',
      component: () => import(/* webpackChunkName: "Scaling" */ './views/processing/scaling/Scaling.vue')
    },   
    {
      path: '/processing/calculated',
      name: 'Calculated',
      component: () => import(/* webpackChunkName: "Calculated" */ './views/processing/calculated/Calculated.vue')
    },
    {
      path: '/processing/converted',
      name: 'Converted',
      component: () => import(/* webpackChunkName: "Converted" */ './views/processing/converted/Converted.vue')
    },
    {
      path: '/qualitycontrol/verify',
      name: 'QAVerify',
      component: () => import(/* webpackChunkName: "QAVerify" */ './views/qualitycontrol/verify/Verify.vue')
    },
    {
      path: '/qualitycontrol/validate',
      name: 'QAValidate',
      component: () => import(/* webpackChunkName: "QAValidate" */ './views/qualitycontrol/validate/Validate.vue')
    },
    {
      path: '/management/responsible_authorities',
      name: 'ResponsibleAuthorities',
      component: () => import(/* webpackChunkName: "responsibleauthorities" */ './views/management/responsible_authorities/ResponsibleAuthorities.vue')
    },
    {
      path: '/management/networks',
      name: 'Networks',
      component: () => import(/* webpackChunkName: "networks" */ './views/management/networks/Networks.vue')
    },
    {
      path: '/management/stations',
      name: 'Stations',
      component: () => import(/* webpackChunkName: "stations" */ './views/management/stations/Stations.vue')
    },
    {
      path: '/management/samplingpoints',
      name: 'SamplingPoints',
      component: () => import(/* webpackChunkName: "sampling_points" */ './views/management/samplingpoints/Samplingpoints.vue')
    },
    {
       path: '/management/processes',
       name: 'Processes',
       // route level code-splitting
       // this generates a separate chunk (about.[hash].js) for this route
       // which is lazy-loaded when the route is visited.
       component: () => import(/* webpackChunkName: "processes" */ './views/management/processes/Processes.vue')
    },
    {
       path: '/management/samples',
       name: 'Samples',
       component: () => import(/* webpackChunkName: "samples" */ './views/management/samples/Samples.vue')
    },
    {
      path: '/management/observing_capabilities',
      name: 'ObservingCapabilities',
      component: () => import(/* webpackChunkName: "observing_capabilities" */ './views/management/observing_capabilities/ObservingCapabilities.vue')
    },
    {
      path: '/management/assessment_regimes',
      name: 'AssessmentRegimes',
      component: () => import(/* webpackChunkName: "assessment_regimes" */ './views/management/assessment_regimes/AssessmentRegimes.vue')
    },
    {
      path: '/management/attainments',
      name: 'Attainments',
      component: () => import(/* webpackChunkName: "attainments" */ './views/management/attainments/Attainments.vue')
    },
    {
      path: '/management/exceedance_descriptions',
      name: 'Exceedance Descriptions',
      component: () => import(/* webpackChunkName: "exceedance_descriptions" */ './views/management/exceedance_descriptions/ExceedanceDescriptions.vue')
    },
    {
      path: '/management/observations',
      name: 'Observations',
      component: () => import(/* webpackChunkName: "observations" */ './views/management/observations/Observations.vue')
    },
    {
      path: '/export',
      name: 'Export',
      component: () => import(/* webpackChunkName: "export" */ './views/dataflows/export/Export.vue')
    },
    {
      path: '/users/usermanager',
      name: 'Usermanager',
      component: () => import(/* webpackChunkName: "usermanager" */ './views/users/usermanager/Usermanager.vue')
    },
    {
      path: '/namespace',
      name: 'Namespace',
      component: () => import(/* webpackChunkName: "namespace" */ './views/namespace/Namespace.vue')
    },
    {
      path: '/viewer/historical',
      name: 'Historical',
      component: () => import(/* webpackChunkName: "historical" */ './views/viewer/Historical.vue')
    },
    {
      path: "/users/edit",
      name: "users",
      component: () =>
          import(/* webpackChunkName: "users" */ "./views/users/edit/Edit.vue")
    },
    {
        path: "/users/groups",
        name: "groups",
        component: () =>
            import(/* webpackChunkName: "users" */ "./views/users/groups/Edit.vue")
    },
  ]
})
